import { useState } from 'react';

const DISMISSED_KEY = 'privacy_notice_dismissed';

const PrivacySecurityNotice = () => {
  const [visible, setVisible] = useState(() => {
    return localStorage.getItem(DISMISSED_KEY) !== '1';
  });

  if (!visible) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setVisible(false);
  };

  return (
    <div
      style={{
        background: 'linear-gradient(90deg, #e8f4fd 0%, #f0f9ff 100%)',
        borderBottom: '1px solid #b6d8f0',
        padding: '8px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '0.82rem',
        color: '#1a5276',
        gap: '12px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <i className="bi bi-shield-lock-fill" style={{ fontSize: '1rem', color: '#1a7abf', flexShrink: 0 }}></i>
        <span>
          <strong>Your data is fully protected.</strong> All information is encrypted end-to-end. We do not store, sell,
          or share your data with any third party. Even our creators and developers cannot access your records.
        </span>
      </div>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss privacy notice"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#1a5276',
          fontSize: '1rem',
          lineHeight: 1,
          padding: '2px 4px',
          flexShrink: 0,
          opacity: 0.7,
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
  );
};

export default PrivacySecurityNotice;
